import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import DownloadModalTables from "../../components/DownloadModalTables";
import DebtCollectionNav from "../../components/DebtCollectionNav";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import PortalPopup from "../../components/PortalPopup";
import CostFilter from "../../components/CostFilter";
import DataPicker from "../../components/DataPicker";
import BillingAdjustmentForm from "../../components/BillingAdjustmentForm";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import CTAs from "../../components/CTAs";
import TabState from "../../components/TabState";
import Footer from "../../components/Footer";

const Legal_proceedings_2 = () => {
  const navigate = useNavigate();
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isCostFilterOpen, setCostFilterOpen] = useState(false);
  const [isDataPickerOpen, setDataPickerOpen] = useState(false);
  const [isBillingAdjustmentForm1Open, setBillingAdjustmentForm1Open] =
    useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openCostFilter = useCallback(() => {
    setCostFilterOpen(true);
  }, []);

  const closeCostFilter = useCallback(() => {
    setCostFilterOpen(false);
  }, []);

  const onClickCasesOverview = useCallback(() => {
    navigate("/legal_1");
  }, [navigate]);

  const onClickReportsAndAnalytics = useCallback(() => {
    navigate("/legal_3");
  }, [navigate]);

  const openDataPicker = useCallback(() => {
    setDataPickerOpen(true);
  }, []);

  const closeDataPicker = useCallback(() => {
    setDataPickerOpen(false);
  }, []);

  const onClickGenerate = useCallback(() => {
    navigate("/invoice");
  }, [navigate]);

  const openBillingAdjustmentForm1 = useCallback(() => {
    setBillingAdjustmentForm1Open(true);
  }, []);

  const closeBillingAdjustmentForm1 = useCallback(() => {
    setBillingAdjustmentForm1Open(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/prelbacheck",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/cdi1",
    },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const billing_details = [
    {
      caseId: "1",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "2",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "3",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "4",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "5",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "6",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "7",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "8",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "9",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
    {
      caseId: "10",
      legal_fees: "£2000",
      court_fees: "£100",
      additional_charges: "N/A",
    },
  ];

  const filteredBilling =
    activeTab === "all"
      ? billing_details
      : billing_details.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedCases = filteredBilling.filter(
    (debtor) =>
      debtor.caseId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.legal_fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.court_fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.additional_charges
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  // For legal proceedings tabs
  const tabs = [
    { label: "Case overview", to: "/legal_1" },
    { label: "Billing schedule", to: "/legal_2" },
    { label: "Reports and analytics", to: "/legal_3" },
  ];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-font-family-meta">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-9xl text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5">
            <b className="relative">Legal proceedings and billing</b>
            <div className="relative text-base text-neutrals-neutral-300">
              Get to know time remaining for your LBA
            </div>
          </div>

          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-base text-neutrals-neutral-300">
            <div className="flex flex-row flex-wrap items-start justify-start gap-6">
              {tabs.map((tab) => (
                <TabState key={tab.to} label={tab.label} to={tab.to} />
              ))}
            </div>
            <div className="self-stretch flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900">
              <div className="self-stretch flex flex-col md:flex-row lg:flex-row items-center justify-start gap-6">
                {/* Block 1 */}
                <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch h-[195px] flex flex-row items-start justify-between p-6 box-border gap-0">
                    <div className="flex flex-col items-start justify-start gap-6">
                      <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                        <img
                          className="w-5 relative h-5"
                          alt=""
                          src="assets/calendar.svg"
                        />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-2.5">
                        <div className="relative font-semibold">
                          Billing schedule
                        </div>
                        <div className="relative text-neutrals-neutral-300">
                          <p className="m-0">Next billing date:</p>
                          <p className="m-0">28/11/23</p>
                        </div>
                      </div>
                    </div>
                    <div className="rounded-[20px] bg-primary-primary-50 border-primary-primary-500 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm text-primary-primary-500">
                      <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                      <div className="relative font-semibold">Weekly</div>
                    </div>
                  </div>
                  <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-t-none rounded-b-3xs bg-white border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <CTAs
                      type="Secondarybtn"
                      text="Customise"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M22 6.5h-6M6 6.5H2M10 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM22 17.5h-4M8 17.5H2M14 21a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                      onClick={openDataPicker}
                    />
                  </div>
                </div>
                {/* Block 2 */}
                <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch h-[195px] flex flex-row items-start justify-between p-6 box-border gap-0">
                    <div className="flex flex-col items-start justify-start gap-6">
                      <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                        <img
                          className="w-5 relative h-5"
                          alt=""
                          src="assets/calendar.svg"
                        />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-2.5">
                        <div className="relative font-semibold">
                          Generate invoice
                        </div>
                        <div className="relative text-neutrals-neutral-300">
                          <p className="m-0">Last invoice generated:</p>
                          <p className="m-0">28/11/23</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-t-none rounded-b-3xs bg-white border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <CTAs
                      type="Secondarybtn"
                      text="Generate"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M2 9V6.5C2 4.01 4.01 2 6.5 2H9M15 2h2.5C19.99 2 22 4.01 22 6.5V9M22 16v1.5c0 2.49-2.01 4.5-4.5 4.5H16M9 22H6.5C4.01 22 2 19.99 2 17.5V15M17 9.5v5c0 2-1 3-3 3h-4c-2 0-3-1-3-3v-5c0-2 1-3 3-3h4c2 0 3 1 3 3ZM19 12H5"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                      onClick={onClickGenerate}
                    />
                  </div>
                </div>
                {/* Block 3 */}
                <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch h-[195px] flex flex-row items-start justify-between p-6 box-border gap-0">
                    <div className="flex flex-col items-start justify-start gap-6">
                      <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                        <img
                          className="w-5 relative h-5"
                          alt=""
                          src="assets/calendar.svg"
                        />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-2.5">
                        <div className="relative font-semibold">
                          Adjust billing
                        </div>
                        <div className="relative text-neutrals-neutral-300">
                          <p className="m-0">Next billing date:</p>
                          <p className="m-0">28/11/23</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-t-none rounded-b-3xs bg-white border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <CTAs
                      type="Secondarybtn"
                      text="Fill form"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#2d404e"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.5"
                            d="M14.43 5.93L20.5 12l-6.07 6.07M3.5 12h16.83"
                          ></path>
                        </svg>
                      }
                      onClick={openBillingAdjustmentForm1}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] flex flex-col items-start rounded-3xs justify-start text-sm">
              <div className="w-full rounded-t-3xs rounded-b-none border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-between py-5 px-6 gap-0 text-lg">
                <div className="flex flex-row items-center justify-start gap-2.5">
                  <div className="relative font-semibold">Billing details</div>
                  <div className="rounded-[5px] bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm">
                    <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                    <div className="relative font-semibold">10 cases</div>
                  </div>
                </div>
                <CTAs
                  type="Secondarybtn"
                  text="Download"
                  borderColor="border-neutrals-neutral-100"
                  onClick={openDownloadModalTables}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 11v6l2-2M9 17l-2-2"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  }
                />
              </div>
              <div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] flex flex-row items-center justify-end py-3 px-6 text-neutrals-neutral-300">
                <div className="flex-1 flex flex-row items-start justify-between gap-0">
                  <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-center justify-start py-2.5 px-3.5">
                    <div className="flex flex-row items-center justify-start gap-2.5">
                      <img
                        className="w-5 relative h-5"
                        alt=""
                        src="assets/search.svg"
                      />
                      <div className="relative">{`Search `}</div>
                    </div>
                  </div>

                  <CTAs
                    type="Secondarybtn"
                    text="Filter"
                    borderColor="border-neutrals-neutral-100"
                    onClick={openCostFilter}
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M3 7h18M6 12h12M10 17h4"
                          stroke="#2d404e"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                      </svg>
                    }
                  />
                </div>
              </div>

              {/* Main content */}
              <div className="w-full flex flex-col items-start justify-start">
                <div className="w-full h-auto flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-start">
                    <table className="min-w-full divide-y divide-gray-200 border-collapse">
                      <thead className="bg-column-bg">
                        <tr>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Case id
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Legal fees
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Court fees
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Additional charges
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                        {searchedCases.map((billing_details) => (
                          <tr
                            key={billing_details.id}
                            className="hover:bg-gray"
                          >
                            <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                              {billing_details.caseId}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {billing_details.legal_fees}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {billing_details.court_fees}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                              {billing_details.additional_charges}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                <CTAs
                  type="Secondarybtn"
                  text="Previous"
                  borderColor="border-neutrals-neutral-100"
                />
                <div className="relative">Page 1 of 10</div>
                <CTAs
                  type="Secondarybtn"
                  text="Next"
                  borderColor="border-neutrals-neutral-100"
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isCostFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeCostFilter}
        >
          <CostFilter onClose={closeCostFilter} />
        </PortalPopup>
      )}
      {isDataPickerOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDataPicker}
        >
          <DataPicker onClose={closeDataPicker} />
        </PortalPopup>
      )}
      {isBillingAdjustmentForm1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeBillingAdjustmentForm1}
        >
          <BillingAdjustmentForm onClose={closeBillingAdjustmentForm1} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default Legal_proceedings_2;
